module.exports = __webpack_public_path__ + "img/menu-icon-1-1.5887961f.svg";